import "katex/dist/katex.min.css";
import "suneditor/dist/css/suneditor.min.css";
import "suneditor/src/assets/css/suneditor-contents.css";

import katex from "katex";
import React, {Suspense} from "react";
import styled from "styled-components";
import SunEditor from "suneditor-react";
import {ko} from "suneditor/src/lang";
import PageLoading from "../loading";

const StyleContainer = styled.div`
    width: 100%;
`;

const ViewContainer = styled.div`
    width: 100%;
    max-width: 1680px;
    padding: 0;
`;

export interface UISunEditorProps {
    value?: string;
    valueChanged?: (value: string) => void;
    readOnly?: boolean;
    displayOnly?: boolean;
    autoFocus?: boolean;
}

export default UISunEditor;

function UISunEditor({autoFocus, displayOnly = false, readOnly = false, value, valueChanged}: UISunEditorProps) {
    // const [contents, setContents] = React.useState<string>(value || "");

    const resetEditorContents = (editorContents: string) => {
        // setContents(editorContents);
        if (valueChanged != null) {
            valueChanged(editorContents);
        }
    };

    if (readOnly || displayOnly)
        return <ViewContainer className={"sun-editor-editable"} dangerouslySetInnerHTML={{__html: value || ''}}/>
    else
        return (
        <Suspense fallback={<PageLoading/>}>
            <StyleContainer>
                <SunEditor
                    lang={ko}
                    setContents={value}
                    onChange={(content: string) => {
                        resetEditorContents(content);
                    }}
                    onBlur={(event, content: string) => {
                        resetEditorContents(content);
                    }}

                    setOptions={{
                        mode: "classic",
                        stickyToolbar: "100px",
                        katex: katex,
                        buttonList: [
                            ["undo", "redo"],
                            ["font", "fontSize", "formatBlock", "paragraphStyle", "blockquote"],
                            ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                            ["fontColor", "hiliteColor", "textStyle"],
                            ["removeFormat"],
                            "/",
                            ["outdent", "indent"],
                            ["align", "horizontalRule", "list", "lineHeight"],
                            ["image", "video", "audio", "link"],
                            ["table", "math"],
                            ["fullScreen", "showBlocks", "codeView", "preview", "print"],
                        ],
                        font: ["맑은 고딕", "굴림", "굴림체", "궁서", "궁서체", "돋움", "돋움체", "바탕", "바탕체", "Arial", "Comic Sans MS", "Courier New"],
                        minHeight: "300px",
                        height: "auto",
                    }}
                    autoFocus={autoFocus === true}
                />
            </StyleContainer>
        </Suspense>
    );
}
